import { GetStoryForBuilderMeta, GetStoryForBuilderPayload } from 'types/store/GetStoryForBuilder';
import { createAsyncReducer } from 'utils/Redux';

import { getStoryForBuilderActions } from '../actions';

export default createAsyncReducer<GetStoryForBuilderMeta, GetStoryForBuilderPayload>(getStoryForBuilderActions);
